const Svg = ({ children, className = "" }) => (
  <svg className={`lp-i ${className}`} viewBox="0 0 24 24" aria-hidden="true">{children}</svg>
);

export const Arrow = () => <Svg><path d="M7 17 17 7M8 7h9v9" /></Svg>;
export const ArrowRight = () => <Svg><path d="M5 12h14M13 6l6 6-6 6" /></Svg>;
export const Check = () => <Svg><circle cx="12" cy="12" r="9" /><path d="m8 12 3 3 5-6" /></Svg>;
export const Clock = () => <Svg><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></Svg>;
export const Plus = () => <Svg><path d="M12 5v14M5 12h14" /></Svg>;
export const Euro = () => <Svg><path d="M17 7a5 5 0 1 0 0 10M5 10h8M5 14h8" /></Svg>;
export const Shield = () => <Svg><path d="M12 3 4 6v6c0 4.5 3.4 8 8 9 4.6-1 8-4.5 8-9V6l-8-3Z" /><path d="m9 12 2 2 4-4" /></Svg>;
export const Partner = () => <Svg><path d="M14 7 9 12l5 5M4 12h5" /><circle cx="17" cy="12" r="4" /></Svg>;
export const Doc = () => <Svg><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 8h8M8 12h8M8 16h5" /></Svg>;
export const Civic = () => <Svg><path d="M3 21h18M5 21V10M19 21V10M9 21v-7M15 21v-7M2 10l10-6 10 6" /></Svg>;
